import styled, { css } from 'styled-components';
import { Colors } from '~/config/Colors';
import * as Popover from '@radix-ui/react-popover';

export const InputDate = styled.div`
  width: 100%;

  ${props =>
    props.disabled &&
    css`
      ${Label} {
        opacity: 0.3;
        cursor: not-allowed;
      }
    `}
`;

export const Label = styled.label`
  margin-bottom: 4px;

  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 500;
  line-height: 10px;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  height: 36px;
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 8px;
  cursor: pointer;

  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 300;
  padding-left: 18px;

  text-align: left;
  background: ${Colors.Input_Color_1};

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;

  &::placeholder {
    color: ${Colors.text_Color_1};
  }

  &:focus {
    border-color: ${Colors.Input_Color_2};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const PopoverContent = styled(Popover.Content)`
  width: 280px;
  padding: 16px;
  background: ${Colors.Input_Color_1};
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 12px;
  box-shadow: 0 10px 38px -10px hsla(206, 22%, 7%, 0.35), 0 10px 20px -15px hsla(206, 22%, 7%, 0.2);
  z-index: 1000;

  /* &:focus {
    outline: none;
  } */
`;

export const CalendarSection = styled.div`
  margin-bottom: 12px;

  .rdp-root {
    --rdp-accent-color: ${Colors.Color4};
    --rdp-accent-background-color: ${Colors.Color4};
    --rdp-today-color: ${Colors.Color4};
    --rdp-day-height: 36px;
    --rdp-day-width: 36px;
    --rdp-day_button-height: 36px;
    --rdp-day_button-width: 36px;
    --rdp-disabled-opacity: 0.4;
    --rdp-outside-opacity: 0.5;
    --rdp-nav_button-height: 28px;
    --rdp-nav_button-width: 28px;
    --rdp-months-gap: 0px;
    --rdp-weekday-padding: 4px;
  }

  .rdp-day {
    color: ${Colors.text_Color_1};
    background: transparent;
    font-size: 0.7em;
    font-weight: 300;
  }

  .rdp-today {
    color: ${Colors.Color4};
    font-weight: 500;
  }

  .rdp-outside {
    opacity: 0.3;
  }

  .rdp-dropdown_root {
    option {
      color: ${Colors.text_Color_1};
      opacity: 0.9;
    }
  }

  .rdp-weekday {
    color: ${Colors.Color6};
    font-weight: 500;
    font-size: 0.65em;
    text-align: center;
    opacity: 0.8;
  }

  .rdp-day_button:disabled {
    color: ${Colors.Color6};
    cursor: not-allowed;
    opacity: 0.1;
  }

  .rdp-dropdown {
    appearance: none;
    background: ${Colors.Input_Color_1};
    border-radius: 4px;
    color: ${Colors.text_Color_1};
    font-size: 0.7em;
    padding: 4px 8px;
    cursor: pointer;
  }

  .rdp-dropdown_root {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${Colors.text_Color_1};
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid rgb(255 255 255 / 0.1);
`;

export const Button = styled.button`
  padding: 4px 8px;
  border: none;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;

  ${props =>
    props.variant === 'cancel'
      ? css`
          background: transparent;
          color: ${Colors.text_Color_1};
          border: 1px solid rgb(255 255 255 / 0.15);

          &:hover:not(:disabled) {
            background: rgb(255 255 255 / 0.05);
          }
        `
      : css`
          background: #6796cf;
          color: white;

          &:hover:not(:disabled) {
            background: #5a7fb8;
          }
        `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Error = styled.span`
  color: #ef4444;
  font-size: 0.625rem;
  font-weight: 400;
  margin-top: 0.25rem;
  display: block;
`;
